module.exports = __webpack_public_path__ + "img/sample.8f9920c5.png";